import React, { createContext, type PropsWithChildren } from 'react'
import { type AuthAppState, useAuthorization } from '../../hooks/auth/use-authorization'

export const AuthContext = createContext<AuthAppState>({
  isLoading: true,
  isAuthenticated: false,
  isAuthorized: false,
  accessToken: null,
  requestedResources: { read: [], write: [] }
})

export const AuthContextProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const authAppState = useAuthorization()

  return (
    <AuthContext.Provider value={authAppState}>
      {children}
    </AuthContext.Provider>
  )
}
